$(document).ready(function () {
    const limits = { box: 15, inner: 30 };
    if (window.matchMedia && window.matchMedia("(hover: none)").matches) return; // touch: no magnet, it sticks after a tap

    $(".arrow").each(function () {
      const $box = $(this);
      const $inner = $box.find("svg");
      const $yellow = $box.find(".is-yellow");
      const $white = $box.find(".is-white");

      $box.on("mousemove", function (e) {
        const offset = $box.offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;

        const move = (el, limit) => {
          gsap.to(el, {
            x: ((x / $box.width()) - 0.5) * 1.5 * limit,
            y: ((y / $box.height()) - 0.5) * 1.5 * limit,
            duration: 0.3,
            ease: "power2.out"
          });
        };

        move($box, limits.box);
        move($inner, limits.inner);
      });

      $box.on("mouseleave", function () {
        gsap.to([$box, $inner], { x: 0, y: 0, duration: 0.5, ease: "power2.out" });
      });
    });
});

$(document).ready(function(){
  gsap.registerPlugin(ScrollTrigger);

  // Select all h1 and h2 elements
  $("h1, h2").each(function(index, el){
    // Split each heading individually
    const split = new SplitText(el, { type: "words,chars" });

    // Animate this heading when it comes into view
    gsap.fromTo(split.chars,
      { scale: 0 },
      {
        scale: 1,
        duration: 1,
        stagger: 0.02,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: el,
          start: "top 80%", // trigger when heading is 80% into viewport
          once: true        // play only once
        },
        onComplete: () => {
          gsap.to('.gifimg', { width: 'auto', duration: 0.4, ease: "back.out(6)" });
          gsap.to('.gifimg img', { translateY: '0%', delay: 0.3 });
        }
      }
    );
  });
});

$(document).ready(function(){
  if ($(window).width() > 992) {
    gsap.registerPlugin(ScrollTrigger);
    [".first-text", ".second-text"].forEach(selector => {
      gsap.set(selector, { xPercent: 50 });
      document.querySelectorAll(selector).forEach(el => {
        gsap.to(el, {
          xPercent: -50,
          ease: "none",
          scrollTrigger: {
            trigger: el,              
            start: "top 80%",
            end:   "bottom 20%",
            scrub: true,   
          }
        });
      });
    });
  }
$(function () {
    $(".faqs-title").click(function () {
        $(".open").not(this).removeClass("open").next().slideUp(300).parent().removeClass("active");
        $(this).toggleClass("open").next().slideToggle(300).parent().toggleClass("active");
    });
});

function animateGSAP(selector, fromProps, toProps, extra = {}) {
    gsap.utils.toArray(selector).forEach(function (element) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          end: "bottom 50%",
          toggleActions: "play none none none",
          ...extra,
        },
      });
      tl.fromTo(element, fromProps, toProps);
    });
  }
  animateGSAP("[fade-in-anim]", { opacity: 0, yPercent: 20 }, { duration: 0.5, opacity: 1, yPercent: 0, ease: "cubic" });

  function animateGSAPAttr(attrName, animProps, extraTrigger = {}) {
    gsap.utils.toArray("[" + attrName + "]").forEach(function (el) {
      gsap.from(el, {
        ...animProps,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          toggleActions: "play none none none",
          ...extraTrigger
        }
      });
    });
  }
  
  $(document).ready(function () {
    animateGSAPAttr("scale-down-scrub", {
      scale: 0,
      duration: 0.5,
      ease: "power2.out",
      stagger: 0.2
    });
  });

});

document.addEventListener('DOMContentLoaded', () => {
  const wrapper   = document.querySelector('.mega-menu-entire-wrp');
  const links     = document.querySelectorAll('.mega-link-li');
  const clearActive = () => {
    document
      .querySelectorAll('.mega-link-li, .mega-link-li-images, .mega-menu-entire-wrp')
      .forEach(el => el.classList.remove('active'));
  };
  const addHover = (link) => {
    const targetId = link.dataset.target;
    const img      = document.getElementById(targetId);

    link.addEventListener('mouseenter', () => {
      clearActive();
      link.classList.add('active');
      if (img) img.classList.add('active');
      wrapper?.classList.add('active');       
    });

    link.addEventListener('mouseleave', () => {
      link.classList.remove('active');
      if (img) img.classList.remove('active');
      const anyHovered = document.querySelector('.mega-link-li:hover');
      if (!anyHovered) wrapper?.classList.remove('active');
    });
  };
  links.forEach(addHover);
});

$(document).ready(function () {
  $(document).on('input', '#quantity', function () {
    let val = parseInt($(this).val());
    if (isNaN(val) || val < 2) {
      $(this).val(2);
    }
  });
  $(document).on('click', '[data-quantity-selector="decrease"]', function (e) {
    const input = $(this).closest('.quantity-input').find('#quantity');
    let val = parseInt(input.val());

    if (val <= 2) {
      e.preventDefault();
      input.val(2);
      return false;
    }
  });
// Allow only numbers
$(document).on("input", "#city", function () {
    this.value = this.value.replace(/[^0-9]/g, '');
});

let isShowingError = false;
// Clear button
$(document).on("click", "#is-clear", function () {
    $("#city").val('');
    $("#location").val('');
    localStorage.removeItem("pincode");
    $("#tigger_modal_location .deliver_to").html(
        '<i class="fa fa-map-marker"></i> <strong></strong> <small>Choose location</small>'
    );
    $("#tigger_modal_location .error_message").text('');
     $("#pinMessage").text('');
});
// Detect popup close (works with Shopify Quick-Shop popup)
setInterval(function () {
    const fancyboxOpen = $.fancybox.getInstance() !== null;

    // If popup CLOSED and error was showing → clear error
    if (!fancyboxOpen && isShowingError) {
        $("#pinMessage").text('');
        isShowingError = false;
        return;
    }

    // Original behavior: reset only if popup closed + input empty
    if (!fancyboxOpen) {
        let cityVal = $("#city").val().trim();
        if (cityVal === "") {
            $("#tigger_modal_location .deliver_to").html(
                '<i class="fa fa-map-marker"></i> <strong></strong> <small>Choose location</small>'
            );
            localStorage.removeItem("pincode");
            $("#location").val('');
            $("#pinMessage").text('');
        }
    }
}, 300);

$(document).on("click", ".js-deliver-here", function (e) {
    let pincode = $("#city").val().trim();
    if (pincode === "") {
        e.preventDefault();
        isShowingError = true;
        $("#pinMessage")
            .text("Please enter a valid pincode.")
            .css("color", "red");
        return false;
    } else {
        isShowingError = false;
    }
});
$(document).on('afterClose.fb', function () {
    let cityVal = $("#city").val().trim();

    // If input empty and message exists → clear it
    if (cityVal === "" && $("#pinMessage").text().trim() !== "") {
        $("#pinMessage").text('');
        isShowingError = false;
    }
});

   // Lenis is not loaded on every theme and loses an async race on others.
   // Guarded so its absence is not an uncaught error; nothing below depends on it.
   if (typeof Lenis !== 'undefined') {
   const lenis = new Lenis()
    lenis.on('scroll', (e) => {})
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf)
    lenis.stop();
 
   	$(document).ready(function(){
    	lenis.start();
    })
   }
    
});

